import { redirect } from '@tanstack/react-router';
import { getAuthToken } from '@/lib/auth';
import { refreshToken } from '@/api/client';

export const redirectIfUnauthenticated = async () => {
  const authTokens = getAuthToken();
  if (!authTokens) {
    throw redirect({
      to: '/login',
      search: { redirect: window.location.pathname },
    });
  }
  if (authTokens.expiry < Date.now()) {
    await refreshToken();
  }
};

export const redirectIfAuthenticated = async () => {
  const authTokens = getAuthToken();
  if (authTokens) {
    throw redirect({
      to: '/',
    });
  }
};
